import { z } from 'zod';
import { id, paginationQuery, paginatedResult } from './common.js';

export const practiceBlockInput = z
  .object({
    blocked: z.boolean(),
    reason: z.string().trim().max(1000).nullable().optional(),
    expectedRevision: z.number().int().nonnegative(),
    clientRequestId: z.string().uuid(),
  })
  .strict();
export type PracticeBlockInput = z.infer<typeof practiceBlockInput>;
export const practiceBlockState = z.object({
  locationId: id,
  blocked: z.boolean(),
  revision: z.number().int().nonnegative(),
  reason: z.string().nullable(),
  canBlock: z.boolean(),
  unavailableReason: z.string().nullable(),
});
export type PracticeBlockState = z.infer<typeof practiceBlockState>;
export const practiceBlockStates = z.object({
  canWrite: z.boolean(),
  items: z.array(practiceBlockState),
});
export type PracticeBlockStates = z.infer<typeof practiceBlockStates>;
export const practiceBlockAccess = z.object({ canWrite: z.boolean(), notice: z.string() });
export const practiceBlock = practiceBlockState.extend({
  name: z.string(),
  groupName: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  timezone: z.string().nullable(),
  available: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PracticeBlock = z.infer<typeof practiceBlock>;
export const practiceBlockPage = paginatedResult(practiceBlock).extend({ canWrite: z.boolean() });
export const practiceBlockQuery = paginationQuery
  .extend({
    search: z.string().trim().max(100).optional(),
    status: z.enum(['all', 'blocked', 'restored']).default('blocked'),
  })
  .strict();
export type PracticeBlockQuery = z.infer<typeof practiceBlockQuery>;
export const practiceBlockLocationIds = z
  .array(id.max(200))
  .max(100)
  .refine((values) => new Set(values).size === values.length, 'Choose each location only once.');
export const practiceBlockEvent = z.object({
  id,
  blocked: z.boolean(),
  reason: z.string().nullable(),
  revision: z.number().int().positive(),
  recordedAt: z.string(),
});
export const practiceBlockHistory = paginatedResult(practiceBlockEvent);
